<template>
<div>
    <AppHeader title="Daily Total" />
    <div class="container-fluid">
    <div class="container-fluid left">

      <div class="row" style="padding-left: 15px;">      
        <!-- <div class="col-sm-1">
          <div class="dropdown" style="position:fixed;left:0;top:0;padding:0;margin-top:0;margin-bottom:0">
            <ReportsMenu/>
          </div>          
        </div> -->
        <div class="col-sm-11" style="text-align:center">          
          <div class="col-sm-2" style="text-align:center">
            <div style="text-align:left;color:white; width: auto;">
                <label title="Date" style="font-size:1.5em">Date:</label>
            </div>
          </div>
          <div style="text-align:left">
            <datepicker class="col-sm-2" v-model="state.date" 
              name="selected_date"
              style = "width: max-content"
              format="yyyy-MM-dd"
              @selected="parentfunctionSelectedhandler" 
              @opened="datepickerOpenedFunction" 
              @closed="parentfunctionCloseHandler">
            </datepicker>
          </div>
          <div class="col-sm-2" style="text-align:center">
            <div style="text-align:left;">
              <div style="text-align:center">
                <button class="btn btn-success" style="font-size:1.5em; scale: 1.12;margin-top: 3px;margin-right: 50%;margin-left: -20%" @click="findDailyTotal()">Find</button>  
            </div>
            </div>
          </div>

        </div>  
      </div>    

 
      <div v-if="toggle">
        <br>
      <div class="row table-wrap" style="color: #fff; padding:0 0 0 25%;">
      </div>
        

        <div class="row table-wrap" style="color: #fff; ">
        <table class="table"  style="color: #fff;">
          <thead>
            <tr>
              <th  style="font-size:1.5em">User</th>
              <th  style="font-size:1.5em">Invoices count</th>
              <th  style="font-size:1.5em">Grand total</th>
              <th  style="font-size:1.5em">Discount</th>
              <th  style="font-size:1.5em">items total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dailyTotal in dailyTotals" :key="dailyTotal.partOne">
              <td style="font-size:1.5em;text-align: right;">{{dailyTotal.partOne}}</td>
              <td style="font-size:1.5em;text-align: right;">{{dailyTotal.invoicecount}}</td>
              <td style="font-size:1.5em;text-align: right;">{{formatNumber(dailyTotal.grandtotal)}}</td>
              <td style="font-size:1.5em;text-align: right;">{{formatNumber(dailyTotal.discount)}}</td>
              <td style="font-size:1.5em;text-align: right;">{{dailyTotal.itemtotal}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
  import axios from "axios";
  import commonServices from "@/shared/commonServices"
  import ReportsMenu from "@/components/ReportsMenu";
  import AppHeader from "@/components/AppHeader";
  import Datepicker from 'vuejs3-datepicker';
  import 'vue-date-pick/dist/vueDatePick.css';
  import App from "@/App.vue";

export default {
    mixins: [commonServices],
    mounted() {
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth();
      let day = nowDate.getDate();
      this.state.date = new Date(year+'', month+'',  day+'');
      this.daydate = this.state.date;
      if(localStorage.userId===undefined){
        //this.$router.push({ name: 'login'});
      }
      this.language = 'ar';
      this.handleLanguage();
      this.getLogo();
      
      this.logoImage = '<img src="'+this.logoUrl+'" width="70" height="50" alt="Logo">';
    },    
    components:{ AppHeader,ReportsMenu, Datepicker },
    data: function(){
        return {

          state: {date: new Date(2016, 9,  16)},
          
          reports_ok: false,
          showError: false,
          logoImage: '',
          dailyTotals: [],
          mainErrorMsg: '',
          logoUrl:'',
          jsonData: {},
          dailyTotalJson: {},
          language: 'en',
          languageName: '',
          toggle: true,
          daydate:'',
        }
    },
    methods:{
      parentfunctionSelectedhandler() {
      console.log("state.date", this.state.date)
    },
    datepickerOpenedFunction() {
      console.log("state.date", this.state.date)
    },
    parentfunctionCloseHandler() {
      console.log("state.date", this.state.date)
    },
    findDailyTotal: async function(){
      this.dailyTotalJson.appId = localStorage.appId;
      this.dailyTotalJson.daydate = this.dateToYMD(this.state.date);
      try{
          let dataURL = this.apiURL+'GiftCard/findDailyTotal';
          let response = await axios.post(dataURL, this.dailyTotalJson);  
            console.log(response.data.results)
          if(response.data.status === 'success'){
                this.dailyTotals = response.data.results.dailytotals;
                console.log(this.dailyTotals)
          }
      }
      catch (error){
          console.log(error);
      }
    },   
    }
  }
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
    font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #EEEEEE;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #CCCCCC;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #CCCCCC; */
}
.grid-container-element { 
    display: grid; 
    grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr; 
    grid-gap: 10px; 
    border: 1px solid whitesmoke; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    width: 100%; 
} 
.grid-child-element_ { 
    margin: 10px; 
    border: 1px solid red; 
}
.grid-child-element { 
    margin: 2px; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    padding : 0 px;
    
}

</style>